import { OrderElementSelector } from './dealer.order.obj.config';
let clearTimer = null;
/**
 * 倒计时
 */
export function countdown() {
  let s = 59;
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    enableBtnSend(false);
    const secondElement = sendCodeBtn.querySelector('em');
    secondElement.innerHTML = '' + s + ' 秒';
    let sendCodeTimer = setInterval(function () {
      s--;
      if (s <= 0) {
        clearBtnSend();
      } else {
        secondElement.innerHTML = '' + s + ' 秒';
        enableBtnSend(false);
      }
    }, 1000);
    clearTimer = () => {
      window.clearInterval(sendCodeTimer);
      sendCodeTimer = null;
      clearTimer = null;
    };
  }
}
/**
 * 清除倒计时
 */
export function clearBtnSend() {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    enableBtnSend(true);
    sendCodeBtn.querySelector('em').innerHTML = '获取验证码';
  }
  clearTimer && clearTimer();
}
/**
 * 启用发送按钮
 * @param {*} enabled
 */
export function enableBtnSend(enabled) {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    if (enabled) {
      sendCodeBtn.classList.remove('disabled');
      sendCodeBtn.disabled = false;
    } else {
      sendCodeBtn.classList.add('disabled');
      sendCodeBtn.disabled = true;
    }
  }
}
/**
 * 展示手机验证码
 */
export function showSmsCode() {
  const smsCodeRowElement = document.querySelector(OrderElementSelector.smsCodeRow);
  if (smsCodeRowElement) {
    smsCodeRowElement.classList.remove('fn-hide');
  }
}
/**
 * 隐藏手机验证码
 */
export function hideSmsCode() {
  const smsCodeRowElement = document.querySelector(OrderElementSelector.smsCodeRow);
  if (smsCodeRowElement) {
    smsCodeRowElement.classList.add('fn-hide');
  }
}
/**
 * 是否可以点击发送验证码
 * @returns
 */
export function canSendSms() {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    let clicked = sendCodeBtn.classList.contains('disabled');
    if (clicked) {
      return false;
    }
  }
  return true;
}
/**
 * 获取sms唯一标识
 * @returns
 */
export function getSmsGuid() {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    let guid = sendCodeBtn.getAttribute('sms_guid');
    return guid || '';
  }
  return '';
}
/**
 * 设置sms唯一标识
 * @param {*} guid
 */
export function setSmsGuid(guid) {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    sendCodeBtn.setAttribute('sms_guid', guid);
  }
}
/**
 *
 * @returns
 */
export function getSmsCaptchaId() {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    let smsCaptchaId = sendCodeBtn.getAttribute('sms_captchaId');
    return smsCaptchaId;
  }
  return '';
}
export function setSmsCaptchaId(captchaId) {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    let smsCaptchaId = sendCodeBtn.setAttribute('sms_captchaId', captchaId);
    return smsCaptchaId;
  }
  return '';
}
export function removeSmsCaptchaId() {
  const sendCodeBtn = document.querySelector(OrderElementSelector.sendCode);
  if (sendCodeBtn) {
    sendCodeBtn.removeAttribute('sms_captchaId');
  }
}
/**
 * 清空手机验证码的值
 */
export function clearSmsCode() {
  const smsCodeInput = document.querySelector(OrderElementSelector.smsCode);
  smsCodeInput.value = '';
}
/**
 * 获取smsCode的值
 * @returns
 */
export function getSmsCode() {
  const smsCodeInput = document.querySelector(OrderElementSelector.smsCode);
  return smsCodeInput.value || '';
}
